/* src/app/shared/components/companies-hierarchy-toggle/companies-hierarchy-toggle.component.scss */
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
::-webkit-scrollbar-thumb {
  background: #acacac;
  border-radius: 8px;
}
::-webkit-scrollbar-track {
}
body {
  scrollbar-face-color: #acacac;
  scrollbar-track-color: rgb(213.5, 213.5, 213.5);
}
:host {
  --toggle-height: 40px;
  --mat-button-toggle-height: var(--toggle-height);
  --mat-button-toggle-label-text-weight: bold;
  --mat-button-toggle-selected-state-text-color: #006BB6;
  --mat-button-toggle-selected-state-background-color: #E9FBFF;
}
::ng-deep .mat-button-toggle-appearance-standard .mat-button-toggle-label-content {
  line-height: var(25px) !important;
}
/*# sourceMappingURL=companies-hierarchy-toggle.component.css.map */
